import {
	signInAPI,
	logoutAPI,
	azureSignInAPI,
	tenantAPI,
	orgCurrentCycleAPI,
	impersonateUserAPI,
	supportUserAPI,
	tenantActionOkrAPI,
	userValidationAPI,
} from '../services/SigninService';
import * as actionTypes from './actionTypes';
import { showLoader } from './common';
import { useSnackbar } from 'notistack';

const signInPending = () => ({
	type: actionTypes.SIGIN_PENDING,
});

const signInCompleted = (payload) => ({
	type: actionTypes.SIGIN_SUCCESS,
	payload,
});

const signInFailed = (error) => ({
	type: actionTypes.SIGIN_FAILED,
	error,
});
const logoutSuccess = () => ({
	type: actionTypes.LOGOUT,
});

export const logoutAction = () => {
	return (dispatch) => {
		return logoutAPI()
			.then(() => {
				dispatch(logoutSuccess());
			})
			.catch(() => {
				dispatch(logoutSuccess());
			});
	};
};

export const sigInAction = (data) => {
	return (dispatch) => {
		dispatch(signInPending());
		return signInAPI(data)
			.then((response) => {
				dispatch(signInCompleted(response.data));
			})
			.catch((error) => {
				dispatch(signInFailed(error));
			});
	};
};

export const azureSignInAction = (data) => {
	return (dispatch) => {
		dispatch(showLoader(true));
		return (
			azureSignInAPI(data)
				//return signInAPI(data)
				.then((response) => {
					dispatch(signInCompleted(response.data));
					dispatch(showLoader(false));
				})
				.catch((error) => {
					dispatch(signInFailed(error));
					dispatch(showLoader(false));
				})
		);
	};
};

export const orgCurrentCycleAction = () => {
	return () => {
		return orgCurrentCycleAPI();
	};
};

export const isSupportUser = (data) => {
	return () => {
		return supportUserAPI(data);
	};
};

export const userValidation = (data) => {
	return () => {
		return userValidationAPI(data);
	};
};

export const tenantAction = (data) => {
	return () => {
		return tenantAPI(data);
	};
};

export const tenantActionOkr = (data) => {
	return () => {
		return tenantActionOkrAPI(data);
	};
};

export const updateStatus = () => ({
	type: actionTypes.UPDATE_STATUS,
});

export const currentCycleStatus = (payload) => ({
	type: actionTypes.CURRENT_CYCLE_DATA,
	payload,
});

export const impersonateUser = (data) => {
	return () => {
		return impersonateUserAPI(data);
	};
};
